import { useContext, useState } from 'react';
import Axios from 'axios';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';
import { Button, Col, Modal as AntdModal, Row } from 'antd';
import { Modal as BootstrapModal } from 'react-bootstrap';

/**
 * مودال کانفرم
 */
const Activation = ({
  close,
  openModal,
  command = {},
  controller = '',
  methodIsGet = false,
  methodIsPost = false,
  itIsBootstrap = false,
  title = 'فعال/غیرفعال کردن ماموریت',
}) => {
  const { urldashboard, authentication, handelerrors } =
    useContext(DashboardContext);

  const [submitLoading, setSubmitLoading] = useState(false);

  const submit = async () => {
    setSubmitLoading(true);

    let url = `${urldashboard}/${controller}`;
    try {
      const res = methodIsPost
        ? await Axios.post(url, JSON.stringify(command), {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json',
            },
          })
        : methodIsGet
        ? await Axios.get(url, {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json',
            },
            params: JSON.stringify(command),
          })
        : await Axios.put(url, JSON.stringify(command), {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json',
            },
          });
      const data = res?.data;
      toaster.success(data.message);
      setSubmitLoading(false);
      close();
    } catch (error) {
      setSubmitLoading(false);
      handelerrors(error);
    }
  };

  const modalContent = (
    <>
      {itIsBootstrap && <h4 className='mb-3'>{title}</h4>}
      <Row gutter={20}>
        <Col span={24} className='mb-3'>
          <h3>آیا اطمینان دارید؟</h3>
        </Col>
      </Row>
      <div style={{ display: 'flex', gap: 10 }}>
        <Button
          block
          type='primary'
          loading={submitLoading}
          onClick={submit}
          className='btn btn-primary rounded-0'
        >
          بله
        </Button>
        <Button block danger onClick={close}>
          خیر
        </Button>
      </div>
    </>
  );

  return itIsBootstrap ? (
    <BootstrapModal show={openModal} onHide={close} centered>
      <BootstrapModal.Body>{modalContent}</BootstrapModal.Body>
    </BootstrapModal>
  ) : (
    <AntdModal
      title={title}
      width={500}
      open={openModal}
      onCancel={close}
      closable={false}
      footer={null}
    >
      {modalContent}
    </AntdModal>
  );
};

export default Activation;
